import { css } from "@linaria/core";

export const dateOverlay = css`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: var(--ant-padding-xxs) var(--ant-padding-xs);
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));
  color: rgba(255, 255, 255, 0.85);
  font-size: var(--ant-font-size-sm);
  line-height: var(--ant-line-height-sm);
`;
